// @flow
import * as React from 'react';
import styled, { css } from 'styled-components';
import { Body } from '../../../../birch/typography';
import Arrows from './arrows';
import Theme from '../../../../birch/components/side_navigation/theme';
import TypographyTheme from '../../../../birch/typography/theme';

type ContainerProps = {
  children: React.Node,
};

const Container = ({ children }: ContainerProps) => (
  <ContainerDiv>{children}</ContainerDiv>
);

/* $FlowFixMe This comment suppresses an error found when upgrading Flow to
 * v0.92.0. To view the error, delete this comment and run Flow. */
const ContainerDiv = styled.div`
  background: none;
  padding-right: 8px;
  width: 192px;
`;

/* $FlowFixMe This comment suppresses an error found when upgrading Flow to
 * v0.92.0. To view the error, delete this comment and run Flow. */
const ContainerElement = styled.div`
  ${({ active }) =>
    active &&
    css`
      background: ${Theme.selected.backgroundColor};
      color: ${TypographyTheme.colors.primary};
    `}
  border-radius: 0px 5px 5px 0px;
  font-size: 1rem;
  padding: 0.5rem 0.5rem 0.5rem 1.5rem;
  margin-bottom: 1px;

  &:hover {
    background: ${Theme.hover.backgroundColor};
  }
`;

type LinkProps = {
  children: React.Node,
  href: string,
  active?: boolean,
  hasSubLinks?: boolean,
};

const Link = ({ href, active, children, hasSubLinks }: LinkProps) => (
  <ContainerElement active={active}>
    <StyledLink href={href}>
      <StyledBodyText active={active}>
        <span>{children}</span>
        {hasSubLinks && (
          <RightArrowContainer>
            <Arrows.RightArrow />
          </RightArrowContainer>
        )}
      </StyledBodyText>
    </StyledLink>
  </ContainerElement>
);

const StyledBodyText = styled(Body)`
  color: ${({ active }) =>
    active ? TypographyTheme.colors.primary : TypographyTheme.colors.secondary};
`;

const RightArrowContainer = styled.span`
  float: right;
`;

const StyledLink = styled.a`
  text-decoration: none !important;
  display: block;
`;

type HeaderProps = {
  children: React.Node,
};

const Header = ({ children }: HeaderProps) => (
  <HeaderContainer withoutHover>
    <Body medium>{children}</Body>
  </HeaderContainer>
);

/* $FlowFixMe This comment suppresses an error found when upgrading Flow to
 * v0.92.0. To view the error, delete this comment and run Flow. */
const HeaderContainer = styled(ContainerElement)`
  pointer-events: none;
`;

type BackProps = {
  children: React.Node,
  href: string,
};

const Back = ({ href, children }: BackProps) => (
  <Link href={href}>
    <LeftArrowContainer>
      <Arrows.LeftArrow />
    </LeftArrowContainer>
    {children}
  </Link>
);

const LeftArrowContainer = styled.span`
  padding-right: 8px;
  vertical-align: middle;
`;

export default {
  Link,
  Container,
  Header,
  Back,
};
